//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "lessitem",
  props:{
      data:Object
  }
}



// WEBPACK FOOTER //
// ./src/components/common/lessonitem.vue